import script from "./message-large-stream.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-large-stream.vue?vue&type=script&lang=ts&setup=true"

import "./message-large-stream.vue?vue&type=style&index=0&id=e83c5e04&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e83c5e04"]])

export default __exports__